<template>
  <div>
    <summary-time
      v-if="!displaySummaryTime"
      :frequency-form="frequencyForm"
      :start-date="frequencyForm.startDay"
      :time="frequencyForm.runningTime"
      :timezone="frequencyForm.timezone"
      :selected-holidays="selectedHolidays"
    />
    <trigger-file-field
      class="frequency-content__trigger-file"
      :display-trigger-file="displayTriggerFile"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import SummaryTime from '@/components/frequencyModal/frequencies/helpers/SummaryTime.vue'
import TriggerFileField from '@/components/frequencyModal/frequencies/helpers/TriggerFileField.vue'
import { format } from 'date-fns-tz'

export default {
  name: 'ComplementaryFieldsWrapper',
  components: {
    SummaryTime,
    TriggerFileField,
  },
  props: {
    frequencyForm: {
      type: Object,
      default: /* istanbul ignore next */ () => ({}),
    },
    selectedHolidays: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
    displaySummaryTime: Boolean,
    displayTriggerFile: Boolean,
  },
  data() {
    return {
      startDate: format(new Date(), 'yyyy-MM-dd'),
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.frequency-content {
  &__trigger-file {
    margin-bottom: $mds-space-1-and-a-half-x;
  }
}
</style>
